import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
    selector: 'app-custom-textarea',
    templateUrl: './custom-textarea.component.html',
    styleUrls: ['./custom-textarea.component.scss'],
    standalone: false
})
export class CustomTextareaComponent implements OnInit {
  pdfSrc: string;
  value:any;
  label:any;
  constructor(public modalCtrl: ModalController,private navParams: NavParams) {}

  ngOnInit() {
    this.value = this.navParams.data.value;
    this.label = this.navParams.data.label;
  }
  closeModal() {
    this.modalCtrl.dismiss({
    });
  }
  getValue(){
    this.modalCtrl.dismiss({
      data:this.value
    });
  }

}
